module.exports = __webpack_public_path__ + "static/media/gs.6adf96a8.svg";